import React, { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { columnDefs, defaultColDef } from './utils/definitions-config';
import { TableCard } from '../../extras/PageLayout';
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';

const CoachTable = ({
  rowData,
  editHandler,
  deleteHandler,
  addPinHandler,
  toggleStatusHandler,
}) => {
  const [openPinModal, setOpenPinModal] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState(null);
  const [pin, setPin] = useState('');

  const handleOpenPinModal = (coach) => {
    setSelectedCoach(coach);
    setPin('');
    setOpenPinModal(true);
  };

  const handleClosePinModal = () => {
    setOpenPinModal(false);
    setSelectedCoach(null);
    setPin('');
  };

  const handleSavePin = () => {
    if (!/^\d{4}$/.test(pin)) {
      alert('PIN must be exactly 4 digits');
      return;
    }
    addPinHandler(selectedCoach, pin);
    handleClosePinModal();
  };

  const ActionsRenderer = (params) => {
    const row = params.data;
    console.log("rowrow",row);
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, height: '100%' }}>
        <button
          onClick={() => editHandler(row)}
          aria-label="Edit coach"
          title="Edit"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 28,
            height: 28,
            borderRadius: 6,
            border: '1px solid #E5E7EB',
            backgroundColor: '#F9FAFB',
            cursor: 'pointer',
            transition: 'all 150ms ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#EEF2FF';
            e.currentTarget.style.borderColor = '#C7D2FE';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#F9FAFB';
            e.currentTarget.style.borderColor = '#E5E7EB';
          }}
        >
          <HiOutlinePencil style={{ fontSize: 14, color: '#4F46E5' }} />
        </button>
        <button
          onClick={() => deleteHandler(row)}
          aria-label="Delete coach"
          title="Delete"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 28,
            height: 28,
            borderRadius: 6,
            border: '1px solid #E5E7EB',
            backgroundColor: '#F9FAFB',
            cursor: 'pointer',
            transition: 'all 150ms ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#FEF2F2';
            e.currentTarget.style.borderColor = '#FECACA';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#F9FAFB';
            e.currentTarget.style.borderColor = '#E5E7EB';
          }}
        >
          <HiOutlineTrash style={{ fontSize: 14, color: '#DC2626' }} />
        </button>
        <Tooltip title="Add PIN" arrow>
          <button
            onClick={() => handleOpenPinModal(row)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 28,
              height: 28,
              borderRadius: 6,
              border: '1px solid #E5E7EB',
              backgroundColor: '#F9FAFB',
              cursor: 'pointer',
              transition: 'all 150ms ease',
              fontSize: 12,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#FEF9C3';
              e.currentTarget.style.borderColor = '#FDE68A';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#F9FAFB';
              e.currentTarget.style.borderColor = '#E5E7EB';
            }}
          >
            🔑
          </button>
        </Tooltip>
        {row?.instructor && (
          <Tooltip
            title={
              row.instructor.is_active
                ? "Click to Inactivate"
                : "Click to Activate"
            }
            arrow
          >
            <button
              onClick={() => toggleStatusHandler(row)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: 28,
                minWidth: 80,
                padding: "0 12px",
                borderRadius: 6,
                border: "none",
                backgroundColor: row.instructor.is_active ? "#16A34A" : "#DC2626",
                color: "#fff",
                fontSize: 11,
                fontWeight: 600,
                cursor: "pointer",
                transition: "background-color 150ms ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = row.instructor.is_active
                  ? "#15803D"
                  : "#B91C1C";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = row.instructor.is_active
                  ? "#16A34A"
                  : "#DC2626";
              }}
            >
              {row.instructor.is_active ? "Active" : "Inactive"}
            </button>
          </Tooltip>
        )}
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ActionsRenderer,
  };

  return (
    <TableCard title="Coaches" count={rowData?.length || 0}>
      <AgGridReact
        editHandler={editHandler}
        deleteHandler={deleteHandler}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowData={rowData}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        domLayout="normal"
        rowHeight={52}
        headerHeight={40}
        pagination={true}
        paginationPageSize={10}
        animateRows={true}
        suppressCellFocus
        frameworkComponents={frameworkComponents}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
      />

      <Dialog
        open={openPinModal}
        onClose={handleClosePinModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Add 4-Digit PIN</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="PIN"
            fullWidth
            value={pin}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 4);
              setPin(value);
            }}
            inputProps={{
              maxLength: 4,
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePinModal}>Cancel</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSavePin}
            disabled={pin.length !== 4}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </TableCard>
  );
};

export default CoachTable;
